export class MissingTaskReminderError extends Error {
  constructor(taskId: string) {
    super(`There is no task with id ${taskId} in the store.`);
    this.name = 'MissingTaskReminderError';

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, MissingTaskReminderError.prototype);
  }
}
